/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="17.05"
        height="18.96"
        viewBox="0 0 17.05 18.96"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M0 5c0 1.8.36 4.38 3.72 8.4l.14.17c3.28 4.07 5.74 5 7.52 5.3a5.44 5.44 0 0 0 1 .09 6.15 6.15 0 0 0 4.37-2.1 1.34 1.34 0 0 0 .27-1.17 1.74 1.74 0 0 0-.57-.86l-3-2.28a2.4 2.4 0 0 0-1-.45 2.18 2.18 0 0 0-1.12.27 2.29 2.29 0 0 1-.9.4 2.84 2.84 0 0 1-2.41-.9 9.82 9.82 0 0 1-.89-.94l-.14-.17a8.62 8.62 0 0 1-.74-1.05 2.79 2.79 0 0 1-.41-2.53 2.06 2.06 0 0 1 .57-.79 2.26 2.26 0 0 0 .49-1.05 2.41 2.41 0 0 0-.24-1.12L5.01.83a1.62 1.62 0 0 0-.72-.7 1.31 1.31 0 0 0-1.23.05A5.76 5.76 0 0 0 0 5Zm3.5-3.95a.34.34 0 0 1 .35 0 .92.92 0 0 1 .23.25l1.63 3.36a1.42 1.42 0 0 1 .15.57 1.35 1.35 0 0 1-.2.44 3.31 3.31 0 0 0-.8 1.16 3.73 3.73 0 0 0 .49 3.42 11.58 11.58 0 0 0 .82 1.16l.13.17a13.72 13.72 0 0 0 1 1 3.78 3.78 0 0 0 3.26 1.16 3.42 3.42 0 0 0 1.26-.53 1.14 1.14 0 0 1 .51-.13 1.52 1.52 0 0 1 .53.25l3 2.25a.89.89 0 0 1 .22.29.33.33 0 0 1-.05.32 4.83 4.83 0 0 1-4.42 1.67c-1.61-.29-3.84-1.12-6.92-4.95l-.14-.17c-3.16-3.77-3.53-6.12-3.5-7.75A4.77 4.77 0 0 1 3.5 1.05Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'PhoneIcon';

export default Icon;
